// extracted by mini-css-extract-plugin
export var active = "_2f-2";
export var container = "_2f-0";
export var expired = "_2f-3";
export var hasStatus = "_2f-4";
export var statusChip = "_2f-1";